import { render, staticRenderFns } from "./tabs-template.vue?vue&type=template&id=3720d1cc&scoped=true"
import script from "./tabs-template.vue?vue&type=script&lang=js"
export * from "./tabs-template.vue?vue&type=script&lang=js"
import style0 from "./tabs-template.vue?vue&type=style&index=0&id=3720d1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720d1cc",
  null
  
)

export default component.exports